
import { useState } from 'react';

interface MACase {
  id: string;
  year?: string;
  location: string;
  companyType?: string;
  capital?: string;
  business: string;
  details: string[];
  price: string;
  priceNote?: string;
  status: 'available' | 'negotiating' | 'sold' | 'preparing';
  featured?: boolean;
  soldDate?: string;
  buyerType?: string;
}

export default function CaseListSection() {
  const [selectedCase, setSelectedCase] = useState<MACase | null>(null);

  const cases: MACase[] = [
    {
      id: 'S-024',
      year: '平成28年',
      location: '東京都',
      companyType: '株式会社',
      capital: '500万円',
      business: '飲食店（居酒屋チェーン）',
      details: [
        '都内に3店舗展開、駅近の好立地物件',
        '年商約1.8億円、営業利益率12%の優良店舗',
        '従業員15名（正社員5名、アルバイト10名）',
        '独自の仕入れルートと人気メニューあり',
        '内装設備は全店舗リニューアル済み'
      ],
      price: '8,500万円',
      status: 'sold',
      soldDate: '2024年11月',
      buyerType: '飲食業経営者',
      featured: true
    },
    {
      id: 'S-023',
      year: '令和元年',
      location: '大阪府',
      companyType: '株式会社',
      capital: '1,000万円',
      business: 'IT受託開発会社',
      details: [
        'エンジニア12名在籍、技術力の高いチーム',
        '大手企業との継続取引多数、安定受注',
        '年商約2.5億円、営業利益率18%',
        'クラウドサービス開発に強み',
        '顧客満足度が高く、リピート率90%以上'
      ],
      price: '1.2億円',
      status: 'sold',
      soldDate: '2024年10月',
      buyerType: 'IT企業'
    },
    {
      id: 'S-022',
      year: '平成25年',
      location: '神奈川県',
      companyType: '株式会社',
      capital: '300万円',
      business: '美容室（3店舗展開）',
      details: [
        '横浜市内に3店舗、地域密着型経営',
        '固定客多数、月間来店数約800名',
        '年商約6,000万円、安定した収益',
        '優秀なスタイリスト8名在籍',
        '店舗物件は全て居抜き可能'
      ],
      price: '4,200万円',
      status: 'sold',
      soldDate: '2024年10月',
      buyerType: '美容業界経営者',
      featured: true
    },
    {
      id: 'S-021',
      year: '令和2年',
      location: '福岡県',
      companyType: '株式会社',
      capital: '800万円',
      business: 'ECサイト運営（アパレル）',
      details: [
        '自社ブランドのアパレルEC、会員数2万人超',
        '年商約1.5億円、営業利益率20%',
        'SNSフォロワー合計5万人以上',
        '在庫管理システム・物流網完備',
        'インフルエンサーとのコラボ実績多数'
      ],
      price: '9,800万円',
      status: 'sold',
      soldDate: '2024年9月',
      buyerType: 'アパレル企業'
    },
    {
      id: 'S-020',
      year: '平成30年',
      location: '愛知県',
      companyType: '株式会社',
      capital: '1,500万円',
      business: '介護施設運営',
      details: [
        'デイサービス2施設運営、定員各20名',
        '稼働率95%以上、地域での評判良好',
        '年商約1.2億円、安定収益',
        '介護スタッフ25名、看護師3名在籍',
        '行政からの評価も高く、指導歴なし'
      ],
      price: '1.5億円',
      status: 'sold',
      soldDate: '2024年9月',
      buyerType: '医療法人'
    },
    {
      id: 'S-019',
      year: '令和3年',
      location: '千葉県',
      companyType: '株式会社',
      capital: '600万円',
      business: '学習塾（個別指導）',
      details: [
        '千葉県内に2教室展開、生徒数約150名',
        '合格実績良好、地域での知名度高い',
        '年商約5,000万円、営業利益率25%',
        '講師15名在籍、教材・カリキュラム完備',
        'オンライン授業システムも導入済み'
      ],
      price: '6,500万円',
      status: 'sold',
      soldDate: '2024年8月',
      buyerType: '教育関連企業',
      featured: true
    },
    {
      id: 'S-018',
      year: '平成27年',
      location: '埼玉県',
      companyType: '株式会社',
      capital: '1,000万円',
      business: '運送業（一般貨物）',
      details: [
        '一般貨物自動車運送事業許可保有',
        '車両15台保有、ドライバー20名在籍',
        '年商約2億円、大手企業との定期契約あり',
        '倉庫施設も保有、保管業務も対応可能',
        '安全運転記録良好、事故率低い'
      ],
      price: '1.8億円',
      status: 'sold',
      soldDate: '2024年8月',
      buyerType: '物流企業'
    },
    {
      id: 'S-017',
      year: '令和元年',
      location: '兵庫県',
      companyType: '株式会社',
      capital: '500万円',
      business: 'フィットネスジム',
      details: [
        '神戸市内の好立地、会員数約600名',
        '24時間営業、最新マシン完備',
        '年商約8,000万円、営業利益率30%',
        'パーソナルトレーニングも好評',
        '退会率が低く、安定した会員数'
      ],
      price: '7,200万円',
      status: 'sold',
      soldDate: '2024年7月',
      buyerType: 'フィットネス業界'
    },
    {
      id: 'S-016',
      year: '平成26年',
      location: '静岡県',
      companyType: '株式会社',
      capital: '800万円',
      business: '製造業（食品加工）',
      details: [
        '地域特産品を使用した食品製造',
        '年商約1.5億円、営業利益率15%',
        'スーパー・百貨店との取引多数',
        '工場設備は最新、HACCP認証取得済み',
        'オンライン販売も展開中'
      ],
      price: '1.1億円',
      status: 'sold',
      soldDate: '2024年7月',
      buyerType: '食品メーカー'
    },
    {
      id: 'S-015',
      year: '令和2年',
      location: '広島県',
      companyType: '株式会社',
      capital: '300万円',
      business: 'Webマーケティング会社',
      details: [
        'SEO・SNS運用に強み、クライアント50社以上',
        '年商約6,000万円、営業利益率35%',
        'リモートワーク体制完備、社員10名',
        '継続契約率90%以上の高い顧客満足度',
        '独自のマーケティングツールも保有'
      ],
      price: '5,500万円',
      status: 'sold',
      soldDate: '2024年6月',
      buyerType: 'IT企業',
      featured: true
    },
    {
      id: 'S-014',
      year: '平成29年',
      location: '京都府',
      companyType: '株式会社',
      capital: '1,200万円',
      business: '不動産管理会社',
      details: [
        '管理物件約200戸、京都市内中心',
        '年商約1億円、安定した管理手数料収入',
        '入居率95%以上、優良物件多数',
        '社員8名、管理業務システム完備',
        'オーナーとの信頼関係良好'
      ],
      price: '9,000万円',
      status: 'sold',
      soldDate: '2024年6月',
      buyerType: '不動産会社'
    },
    {
      id: 'S-013',
      year: '令和3年',
      location: '宮城県',
      companyType: '株式会社',
      capital: '400万円',
      business: 'カフェ（2店舗）',
      details: [
        '仙台市内に2店舗、おしゃれな内装で人気',
        '年商約4,000万円、営業利益率20%',
        'SNSでの集客に成功、フォロワー3万人',
        'オリジナルスイーツが好評',
        'テイクアウト・デリバリーも好調'
      ],
      price: '3,800万円',
      status: 'sold',
      soldDate: '2024年5月',
      buyerType: '飲食業経営者'
    }
  ];

  const getStatusBadge = (status: string) => {
    const badges = {
      available: { text: '募集中', color: 'bg-teal-500' },
      negotiating: { text: '交渉中', color: 'bg-amber-500' },
      sold: { text: '成約済', color: 'bg-gray-500' },
      preparing: { text: '準備中', color: 'bg-blue-500' }
    };
    const badge = badges[status as keyof typeof badges];
    return (
      <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-bold text-white ${badge.color}`}>
        {badge.text}
      </span>
    );
  };

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-6 py-3 bg-gray-100 rounded-full mb-6">
            <i className="ri-checkbox-circle-line text-gray-700 text-xl mr-3"></i>
            <span className="text-gray-700 font-bold text-sm">Success Cases</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            成約実績
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            これまでに成約した案件の一部をご紹介します。様々な業種・規模の実績がございます。
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          <div className="bg-white rounded-2xl shadow-lg p-6 text-center border-2 border-gray-100">
            <div className="text-4xl font-black text-teal-600 mb-2">{cases.length}件</div>
            <div className="text-sm text-gray-600 font-bold">成約実績</div>
          </div>
          <div className="bg-white rounded-2xl shadow-lg p-6 text-center border-2 border-gray-100">
            <div className="text-4xl font-black text-teal-600 mb-2">98%</div>
            <div className="text-sm text-gray-600 font-bold">顧客満足度</div>
          </div>
          <div className="bg-white rounded-2xl shadow-lg p-6 text-center border-2 border-gray-100">
            <div className="text-4xl font-black text-teal-600 mb-2">45日</div>
            <div className="text-sm text-gray-600 font-bold">平均成約期間</div>
          </div>
          <div className="bg-white rounded-2xl shadow-lg p-6 text-center border-2 border-gray-100">
            <div className="text-4xl font-black text-teal-600 mb-2">100%</div>
            <div className="text-sm text-gray-600 font-bold">成約後満足度</div>
          </div>
        </div>

        {/* Notice */}
        <div className="bg-gradient-to-r from-teal-50 to-cyan-50 border-l-4 border-teal-500 rounded-xl p-6 mb-12">
          <div className="flex items-start">
            <div className="w-12 h-12 bg-teal-500 rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
              <i className="ri-information-line text-2xl text-white"></i>
            </div>
            <div>
              <h3 className="font-black text-gray-900 mb-2 text-lg">掲載について</h3>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 mr-2 mt-1"></i>
                  <span>こちらは過去の成約事例の一部です</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 mr-2 mt-1"></i>
                  <span>詳細はNO.をクリックしてご覧ください</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-500 mr-2 mt-1"></i>
                  <span>現在募集中の案件は別ページをご覧ください</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Cases Grid */}
        <div className="grid grid-cols-1 gap-6 mb-16">
          {cases.map((caseItem) => (
            <div
              key={caseItem.id}
              className={`group relative bg-white rounded-2xl shadow-sm hover:shadow-2xl transition-all duration-500 overflow-hidden border-2 ${
                caseItem.featured ? 'border-teal-300' : 'border-gray-100'
              }`}
            >
              {caseItem.featured && (
                <div className="absolute top-4 right-4 z-10">
                  <span className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-full text-xs font-bold shadow-lg">
                    <i className="ri-trophy-fill mr-2"></i>
                    注目実績
                  </span>
                </div>
              )}

              <div className="p-8">
                <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6">
                  {/* Left: Case Info */}
                  <div className="flex-1">
                    <div className="flex items-center gap-4 mb-4">
                      <div className="w-16 h-16 bg-gradient-to-br from-gray-600 to-gray-800 rounded-2xl flex items-center justify-center flex-shrink-0">
                        <span className="text-xl font-black text-white">{caseItem.id}</span>
                      </div>
                      <div>
                        <div className="flex items-center gap-3 mb-2">
                          {getStatusBadge(caseItem.status)}
                          {caseItem.soldDate && (
                            <span className="text-xs font-bold text-gray-600 bg-gray-100 px-3 py-1 rounded-full">
                              {caseItem.soldDate}成約
                            </span>
                          )}
                          {caseItem.companyType && (
                            <span className="text-sm font-bold text-gray-600 bg-gray-100 px-3 py-1 rounded-full">
                              {caseItem.companyType}
                            </span>
                          )}
                        </div>
                        <h3 className="text-xl font-black text-gray-900">{caseItem.business}</h3>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                      {caseItem.year && (
                            <div className="flex items-center">
                              <i className="ri-calendar-line text-teal-500 mr-2"></i>
                              <span className="text-sm text-gray-600">{caseItem.year}</span>
                            </div>
                          )}
                          <div className="flex items-center">
                            <i className="ri-map-pin-line text-teal-500 mr-2"></i>
                            <span className="text-sm text-gray-600">{caseItem.location}</span>
                          </div>
                          {caseItem.capital && (
                            <div className="flex items-center">
                              <i className="ri-money-dollar-circle-line text-teal-500 mr-2"></i>
                              <span className="text-sm text-gray-600">資本金 {caseItem.capital}</span>
                            </div>
                          )}
                          {caseItem.buyerType && (
                            <div className="flex items-center">
                              <i className="ri-user-line text-teal-500 mr-2"></i>
                              <span className="text-sm text-gray-600">買手: {caseItem.buyerType}</span>
                            </div>
                          )}
                    </div>

                    <ul className="space-y-2 mb-4">
                      {caseItem.details.map((detail, idx) => (
                        <li key={idx} className="flex items-start text-sm text-gray-700">
                          <i className="ri-checkbox-circle-fill text-teal-500 mr-2 mt-1 flex-shrink-0"></i>
                          <span>{detail}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Right: Price & Action */}
                  <div className="lg:text-right flex-shrink-0">
                    <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl p-6 mb-4">
                      <p className="text-sm text-gray-600 mb-2 font-bold">成約価格</p>
                      <p className="text-3xl font-black text-gray-900 mb-1">{caseItem.price}</p>
                      {caseItem.priceNote && (
                        <p className="text-xs text-gray-600 font-bold">（{caseItem.priceNote}）</p>
                      )}
                    </div>
                    <button
                      onClick={() => setSelectedCase(caseItem)}
                      className="w-full px-8 py-4 bg-gradient-to-r from-gray-600 to-gray-800 text-white rounded-xl font-bold hover:shadow-xl hover:shadow-gray-500/30 transition-all duration-300 flex items-center justify-center whitespace-nowrap cursor-pointer group"
                    >
                      詳細を見る
                      <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Success Factors */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white rounded-2xl shadow-lg p-8 border-2 border-gray-100">
            <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl flex items-center justify-center mb-6 mx-auto">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-black text-gray-900 mb-4 text-center">徹底した事前調査</h3>
            <p className="text-sm text-gray-700 text-center">
              財務状況、法的リスク、事業の将来性など、多角的な視点から徹底的に調査を行い、安心・安全な取引をサポートします。
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 border-2 border-gray-100">
            <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-2xl flex items-center justify-center mb-6 mx-auto">
              <i className="ri-team-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-black text-gray-900 mb-4 text-center">最適なマッチング</h3>
            <p className="text-sm text-gray-700 text-center">
              売り手と買い手双方のニーズを深く理解し、最適な組み合わせをご提案。成約後も円滑な事業承継をサポートします。
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 border-2 border-gray-100">
            <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl flex items-center justify-center mb-6 mx-auto">
              <i className="ri-time-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-black text-gray-900 mb-4 text-center">スピーディな対応</h3>
            <p className="text-sm text-gray-700 text-center">
              平均45日での成約実績。経験豊富な専門スタッフが、迅速かつ丁寧に手続きを進め、スムーズな取引を実現します。
            </p>
          </div>
        </div>

        {/* Testimonials */}
        <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-3xl p-12">
          <h3 className="text-3xl font-black text-gray-900 mb-8 text-center">お客様の声</h3>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-line text-2xl text-white"></i>
                </div>
                <div>
                  <div className="font-black text-gray-900">飲食業 A様</div>
                  <div className="text-xs text-gray-600">売却側</div>
                </div>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">
                後継者不在で悩んでいましたが、NEXTAGEさんのおかげで理想的な買い手が見つかりました。従業員の雇用も守られ、安心して引き継ぐことができました。
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-line text-2xl text-white"></i>
                </div>
                <div>
                  <div className="font-black text-gray-900">IT企業 B様</div>
                  <div className="text-xs text-gray-600">買収側</div>
                </div>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">
                事業拡大のために優良企業を探していました。詳細な情報提供と丁寧なサポートで、スムーズに買収を完了できました。期待以上の成果です。
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-line text-2xl text-white"></i>
                </div>
                <div>
                  <div className="font-black text-gray-900">不動産業 C様</div>
                  <div className="text-xs text-gray-600">売却側</div>
                </div>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">
                初めてのM&Aで不安でしたが、専門スタッフの方が親身になって相談に乗ってくださり、納得のいく条件で成約できました。本当に感謝しています。
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-line text-2xl text-white"></i>
                </div>
                <div>
                  <div className="font-black text-gray-900">製造業 D様</div>
                  <div className="text-xs text-gray-600">買収側</div>
                </div>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">
                技術力のある企業を探していました。NEXTAGEさんの的確なマッチングで、シナジー効果の高い企業と出会えました。今後の成長が楽しみです。
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {selectedCase && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setSelectedCase(null)}>
          <div className="bg-white rounded-3xl max-w-3xl w-full max-h-[90vh] overflow-y-auto shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-gray-600 to-gray-800 p-6 flex items-center justify-between">
              <h3 className="text-2xl font-black text-white">成約事例詳細 - {selectedCase.id}</h3>
              <button
                onClick={() => setSelectedCase(null)}
                className="w-10 h-10 bg-white/20 backdrop-blur-md rounded-xl flex items-center justify-center hover:bg-white/30 transition-all cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-white"></i>
              </button>
            </div>
            <div className="p-8">
              <div className="mb-6 flex items-center gap-3">
                {getStatusBadge(selectedCase.status)}
                {selectedCase.soldDate && (
                  <span className="text-sm font-bold text-gray-600 bg-gray-100 px-4 py-2 rounded-full">
                    {selectedCase.soldDate}成約
                  </span>
                )}
              </div>
              <h4 className="text-2xl font-black text-gray-900 mb-6">{selectedCase.business}</h4>
              
              <div className="grid grid-cols-2 gap-4 mb-6">
                {selectedCase.year && (
                  <div className="bg-gray-50 rounded-xl p-4">
                    <p className="text-xs text-gray-500 mb-1">設立年</p>
                    <p className="font-bold text-gray-900">{selectedCase.year}</p>
                  </div>
                )}
                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-xs text-gray-500 mb-1">所在地</p>
                  <p className="font-bold text-gray-900">{selectedCase.location}</p>
                </div>
                {selectedCase.companyType && (
                  <div className="bg-gray-50 rounded-xl p-4">
                    <p className="text-xs text-gray-500 mb-1">法人形態</p>
                    <p className="font-bold text-gray-900">{selectedCase.companyType}</p>
                  </div>
                )}
                {selectedCase.capital && (
                  <div className="bg-gray-50 rounded-xl p-4">
                    <p className="text-xs text-gray-500 mb-1">資本金</p>
                    <p className="font-bold text-gray-900">{selectedCase.capital}</p>
                  </div>
                )}
                {selectedCase.buyerType && (
                  <div className="bg-gray-50 rounded-xl p-4 col-span-2">
                    <p className="text-xs text-gray-500 mb-1">買手</p>
                    <p className="font-bold text-gray-900">{selectedCase.buyerType}</p>
                  </div>
                )}
              </div>

              <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-6 mb-6">
                <h5 className="font-black text-gray-900 mb-4">案件詳細</h5>
                <ul className="space-y-3">
                  {selectedCase.details.map((detail, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-teal-500 mr-3 mt-1 flex-shrink-0"></i>
                      <span className="text-gray-700">{detail}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-gray-900 rounded-2xl p-6 mb-6">
                <p className="text-sm text-gray-400 mb-2">成約価格</p>
                <p className="text-4xl font-black text-white mb-2">{selectedCase.price}</p>
                {selectedCase.priceNote && (
                  <p className="text-sm text-teal-400 font-bold">（{selectedCase.priceNote}）</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
